var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { defaultApiConfig } from '@unitarius/xbpm-runtime';
import { injector } from './injector';
// env config
var _a = process.env, NODE_ENV = _a.NODE_ENV, PUBLIC_URL = _a.PUBLIC_URL, REACT_APP_VERSION = _a.REACT_APP_VERSION, 
// auth
REACT_APP_AUTH_TYPE = _a.REACT_APP_AUTH_TYPE, REACT_APP_AUTH_FORCE_LOGIN = _a.REACT_APP_AUTH_FORCE_LOGIN, 
// oauth
REACT_APP_OAUTH_AUTHORITY = _a.REACT_APP_OAUTH_AUTHORITY, REACT_APP_OAUTH_CLIENT_ID = _a.REACT_APP_OAUTH_CLIENT_ID, REACT_APP_OAUTH_SESSION_MONITOR = _a.REACT_APP_OAUTH_SESSION_MONITOR, 
// nav
REACT_APP_NAV_HOME = _a.REACT_APP_NAV_HOME;
// injector tokens
export var MAP_AUTH_CONFIG_TOKEN = Symbol('MAP_AUTH_CONFIG');
export var MAP_API_CONFIG_TOKEN = Symbol('MAP_API_CONFIG');
export var MAP_NAV_CONFIG_TOKEN = Symbol('MAP_NAV_CONFIG');
export var FETCH_CONFIG_TOKEN = Symbol('FETCH_CONFIG');
// default handlers
export var mapAuthConfig = function (config) {
    if (config) {
        return config;
    }
    if (REACT_APP_AUTH_TYPE) {
        switch (REACT_APP_AUTH_TYPE.toLowerCase()) {
            case 'oauth':
                return {
                    $kind: 'oauth',
                    client_id: REACT_APP_OAUTH_CLIENT_ID,
                    authority: REACT_APP_OAUTH_AUTHORITY,
                    automaticLogin: REACT_APP_AUTH_FORCE_LOGIN === 'true',
                    monitorSession: REACT_APP_OAUTH_SESSION_MONITOR === 'true',
                };
        }
    }
    return null;
};
export var mapApiConfig = function (config) {
    if (config) {
        return config;
    }
    return __assign(__assign({ mock: false }, defaultApiConfig), (PUBLIC_URL ? { baseURL: "" + PUBLIC_URL + defaultApiConfig.baseURL } : {}));
};
export var mapNavConfig = function (config) {
    if (config) {
        return config;
    }
    return { home: REACT_APP_NAV_HOME || '/' };
};
export var fetchConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
    var clientConfigData, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                clientConfigData = null;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios
                        .get("/env/config.json", { baseURL: PUBLIC_URL, responseType: 'json' })
                        .then(function (res) { return res.data; }, function () { return null; })];
            case 2:
                clientConfigData = _a.sent();
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                console.error(error_1);
                return [3 /*break*/, 4];
            case 4: 
            // creating & returning a complete config
            return [2 /*return*/, __assign({}, clientConfigData)];
        }
    });
}); };
// bind default handlers
injector.bind(MAP_AUTH_CONFIG_TOKEN).toConstantValue(mapAuthConfig);
injector.bind(MAP_API_CONFIG_TOKEN).toConstantValue(mapApiConfig);
injector.bind(MAP_NAV_CONFIG_TOKEN).toConstantValue(mapNavConfig);
injector.bind(FETCH_CONFIG_TOKEN).toConstantValue(fetchConfig);
// fetch config
export var getConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a, authConfig, apiConfig, navConfig, config;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, injector.get(FETCH_CONFIG_TOKEN)()];
            case 1:
                _a = _b.sent(), authConfig = _a.authConfig, apiConfig = _a.apiConfig, navConfig = _a.navConfig;
                config = {
                    production: NODE_ENV === 'production',
                    baseUrl: PUBLIC_URL,
                    version: REACT_APP_VERSION,
                    authConfig: injector.get(MAP_AUTH_CONFIG_TOKEN)(authConfig),
                    apiConfig: injector.get(MAP_API_CONFIG_TOKEN)(apiConfig),
                    navConfig: injector.get(MAP_NAV_CONFIG_TOKEN)(navConfig),
                };
                console.info('XBPM Front Configuration:', JSON.stringify(config, null, ' '));
                return [2 /*return*/, config];
        }
    });
}); };
//# sourceMappingURL=config.js.map